import React from 'react';
import { FormattedMessage } from 'react-intl';

import Constants from '../../../../definitions/constants';
import FormatTooling from '../../../../tooling/formatTooling';
import { intl } from '../../../../locales/localesConfig';

import Spinner from '../interface/spinner';
import TextBox from '../inputs/textBox';
import CheckBox from '../inputs/checkBox';

const AssignTable = props => {
  const {
    nameProperty,
    assignTypeLabel,
    data,
    assignId,
    noAssignText,
    loading,
    page,
    totalPages,
    totalRecords,
    searchText,
    handleOnChangeSearch,
    fetchListChangePage,
    handleCheckBoxClick,
    saveAssignData,
    className
  } = props;
  return (
    <div className={"table_component assign_table_component" + (className ? " " + className : "")}>
      <div className="top_controls">
        <TextBox 
          className="top_controls_search"
          styleType={Constants.interface.inputs.styleType.OUTLINED}
          type={Constants.interface.inputs.type.TEXT}
          id="assignSearchText"
          value={searchText}
          onChange={handleOnChangeSearch}
          disabled={assignId==null ? true : false}
          labelLocale={<FormattedMessage 
            id="common.entity.findEntity"
            values={{entityNamePlural: assignTypeLabel}}
          />}
          showClearTextButton={true}
        />
        <div className="registers_info">
          <span className="page_info page_info_total">
            {(totalRecords ? totalRecords : 0) + " " + assignTypeLabel + " - "}
          </span>
          {(page>1) && (
            <span className="pag_arrow pag_arrow_left" data-targetpage={page-1} onClick={fetchListChangePage}>
              <i className="fas fa-caret-square-left"></i>
            </span>
          )}
          <span className="page_info">
            <FormattedMessage 
              id="common.entity.entityTable.pageInfo"
              values={{page: totalPages==0 ? 0 : Math.min(page,totalPages), totalPages: totalPages}}
            />
          </span>
          {(page<totalPages && totalPages>1) && (
            <span className="pag_arrow pag_arrow_right" data-targetpage={page+1} onClick={fetchListChangePage}>
              <i className="fas fa-caret-square-right"></i>
            </span>
          )}
        </div>
      </div>
      <div className="table_component_table_wrapper">
        <div className="table_component_table_header_wrapper">
          <table>
            <thead>
              <tr>
                <th className="check_column"></th>
                <th title={intl.formatMessage({ id: "common.assign.headers.name" })}>
                  <FormattedMessage id="common.assign.headers.name"/>
                </th>
              </tr>
            </thead>
          </table>
        </div>
        <div className="table_component_table_body_wrapper">
          <table>
            <thead>
              <tr>
                <th className="check_column">{" "}</th>
                <th>{" "}</th>
              </tr>
            </thead>
            <tbody>
            {data && data.map((record,i) => {
              return (
                <tr key={i}>
                  <td className="check_column">
                    {(record.id == saveAssignData.assignId && saveAssignData.loading == true) ? (
                      <Spinner/>
                    ) : (
                      <CheckBox 
                        className="check_column_checkbox"
                        data-assignid={assignId}
                        data-assignentity={JSON.stringify(record)}
                        value={
                          record.external_asign_names ? true :
                          (record.related_entity_id==null ? false : true)
                        }
                        onChange={handleCheckBoxClick}
                        disabled={record.external_asign_names ? true : saveAssignData.loading}
                      />
                    )}
                  </td>
                  <td>
                    <div title={record[nameProperty] + (record.external_asign_names ? 
                      " (" + intl.formatMessage({ id: "common.assign.assignIn" }) + ": " + 
                      record.external_asign_names + ")" : "") + 
                      (record.association_code ? (" (" + intl.formatMessage({ id: "common.assign.associationCode" }) + ": " + record.association_code + ")") : "")  
                    }>
                      {record[nameProperty]}
                      <span className="assign_in_span">
                        {(record.external_asign_names ? 
                        " (" + intl.formatMessage({ id: "common.assign.assignIn" }) + ": " + 
                         record.external_asign_names + ")" : "") + 
                        (record.association_code ? (" (" + intl.formatMessage({ id: "common.assign.associationCode" }) + ": " + record.association_code + ")") : "")}
                      </span>
                    </div>
                  </td>
                </tr>                      
              );    
            })}
            </tbody>
          </table>
          {assignId==null && (<div className="no_assign_selected">
            {noAssignText}
          </div>)}
          {loading && (<div className="table_eof">
            <Spinner/>
          </div>)}
        </div>
      </div>
    </div>
  );
}

export default AssignTable;



// WEBPACK FOOTER //
// ./source/client/components/common/assign/assignTable.jsx